"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOGS_PREPROCESSOR = exports.DEFAULT_COLUMNS = exports.DEFAULT_LOGFORMAT = void 0;
exports.DEFAULT_LOGFORMAT = `%(host)s %(timestamp)s %(level)5s [%(threadName)s] [%(class)s:%(lineNumber)s] %(message)s`;
exports.DEFAULT_COLUMNS = [
    "host Host",
    "nxdrive.userId nxUser",
    "tags.service TagServ",
    "source Source",
    "http.statusCategory Status",
    "http.url URL"
];
// Handle special fields
exports.LOGS_PREPROCESSOR = (e = {}, { serverPadding = 0 } = {}) => {
    try {
        if (e.timestamp || e.Timestamp) {
            e.timestamp = new Date(e.timestamp || e.Timestamp).toISOString();
        }
        if (e.host && serverPadding) {
            e.host = e.host.padEnd(serverPadding, " ");
        }
        if (e.message) {
            e.message = e.message.replace(/\t/g, " ");
        }
    }
    catch (e) {
        console.log(`[LOGS_PREPROCESSOR] ${e.message}`);
    }
    return e;
};
//# sourceMappingURL=logs.js.map